export interface IAdminSettingEnvelope {
  adminSettingsDTO: IAdminSetting[];
  adminSettingCount: number;
}

export interface IAdminSetting {
  id: string;
  key: string;
  value: string;
}

//interface extention for custom built items like time in a datetime
export interface IAdminSettingFormValues extends Partial<IAdminSetting> {
}

//empty form model
export class AdminSettingFormValues implements IAdminSettingFormValues {
  id: string = "";
  key: string = "";
  value: string = "";

  constructor(id?: string, key?: string, value?: string) {
    if (id) {
      this.id = id;
    }
    if (key) {
      this.key = key;
    }
    if (value) {
      this.value = value;
    }
    Object.assign(this);
  }
}
